import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import axios from "@/setup/axios-setup";
import {config} from '../../../../utils/upload'
import {
  GET_STUDENTASSIGNMENT,
  GET_STUDENTASSIGNMENTS,
  GET_STUDENTASSIGNMENTS_BY_FILTER,
  ADD_STUDENTASSIGNMENT,
  UPDATE_STUDENTASSIGNMENT,
  UPDATE_STUDENTASSIGNMENT_TEACHER_RECEIVE,
  DELETE_STUDENTASSIGNMENT
} from '../../../../queries/modules/student-assingment/student-assignment.js';

export async function getStudentAssignments(context) {

  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTASSIGNMENTS,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });
    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setStudentAssignments', data.getStudentAssignments);
      context.commit('setSuccess', null);
      return data.getStudentAssignments
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getStudentAssignmentsByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTASSIGNMENTS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setStudentAssignments', data.getStudentAssignmentsByFilter);
      context.commit('setSuccess', null);

      return data.getStudentAssignmentsByFilter;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getStudentAssignment(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_STUDENTASSIGNMENT,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setStudentAssignment', data.getStudentAssignment);
      context.commit('setSuccess', null);
      return data.getStudentAssignment
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addStudentAssignment(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_STUDENTASSIGNMENT,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      // const studentAssignments = [...context.state.studentAssignments];
      // studentAssignments.push(data.addStudentAssignment);
      // context.commit('setStudentAssignments', studentAssignments);
      context.commit('setSuccess', newItemSuccess(data.addStudentAssignment.studentCode));

      return data.addStudentAssignment;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateStudentAssignment(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_STUDENTASSIGNMENT,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.studentAssignments.findIndex(item => item.id === data.updateStudentAssignment.id);
      const studentAssignments = [
        ...context.state.studentAssignments.slice(0, index),
        data.updateStudentAssignment,
        ...context.state.studentAssignments.slice(index + 1)
      ];
      context.commit('setStudentAssignments', studentAssignments);
      context.commit('setSuccess', updateItemSuccess(data.updateStudentAssignment.student.code));

      return data.updateStudentAssignment
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateStudentAssignmentTeacherReceive(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_STUDENTASSIGNMENT_TEACHER_RECEIVE,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.studentAssignments.findIndex(item => item.id === data.updateStudentAssignmentTeacherReceive.id);
      const studentAssignments = [
        ...context.state.studentAssignments.slice(0, index),
        data.updateStudentAssignment,
        ...context.state.studentAssignments.slice(index + 1)
      ];
      context.commit('setStudentAssignments', studentAssignments);
      context.commit('setSuccess', updateItemSuccess(data.updateStudentAssignmentTeacherReceive.student.code));

      return data.updateStudentAssignmentTeacherReceive
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteStudentAssignment(context, payload) {
  context.commit('setProcessing', true);

  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_STUDENTASSIGNMENT,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      // const index = context.state.studentAssignments.findIndex(item => item.id === data.deleteStudentAssignment.id);
      // const studentAssignments = [
      //   ...context.state.studentAssignments.slice(0, index),
      //   ...context.state.studentAssignments.slice(index + 1)
      // ];
      // context.commit('setStudentAssignments', studentAssignments);
      context.commit('setSuccess', deleteItemSuccess(data.deleteStudentAssignment.studentCode));

      return data.deleteStudentAssignment
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function uploadStudentAssignment(context, payload){
  const rsc = JSON.parse(localStorage.getItem("rsc"));
  let entity, stage
  if (rsc) {
    entity = rsc.e_code;
    stage = rsc.r_stage;
  }


  const formData = new FormData();
  formData.append('file', payload.file);
  formData.append('file1', payload.fileName);
  formData.append('ext', payload.file.name.substring([payload.file.name.lastIndexOf('.') + 1]));
  formData.append('timestamp', payload.file.lastModified);
  formData.append('operationName', payload.operationName);
  // formData.append('stage', payload.stage);
  // formData.append('entity', payload.entity);
  formData.append('stage', stage);
  formData.append('entity', entity);
  formData.append('authorization', payload.authorization);
  formData.append('app', payload.app);

  try {
    const result = await axios({
      url: config.url.uploadFiles,
      method: 'post',
      headers: {
        'content-type': 'multipart/form-data'
      },
      data: formData,
    });

    const {data} = await result;

    return data;
  } catch (e) {
    // commit('setError', error(e));
    return null;
  }

}

